module.exports = __webpack_public_path__ + "static/media/5_disco-min.01cec9f4.jpg";